import { useNavigate } from "react-router-dom";
import { money, MODE_META, PAYMENT_META } from "@/lib/pricing";
import { isNewOrder } from "@/lib/orderDetails";
import { StatusBadge } from "@/components/StatusTracker";
import { ChevronRight, Sparkles, CakeSlice, AlertTriangle } from "lucide-react";

export const OrderCard = ({ o }) => {
  const navigate = useNavigate();
  const fresh = isNewOrder(o);
  const pay = PAYMENT_META[o.payment_status] || PAYMENT_META.pending;
  return (
    <button
      data-testid={`admin-order-${o.id}`}
      onClick={() => navigate(`/admin/orders/${o.id}`)}
      className={`flex w-full items-center gap-3 rounded-2xl border-2 p-4 text-left transition-transform hover:-translate-y-0.5 ${fresh ? "border-yellow-400 bg-yellow-300 shadow-[0_6px_24px_-8px_rgba(250,204,21,0.9)]" : "border-sugar-border bg-white"}`}
    >
      {o.items[0]?.image
        ? <img src={o.items[0].image} alt="" className="h-14 w-14 shrink-0 rounded-xl object-cover" />
        : <span className="grid h-14 w-14 shrink-0 place-items-center rounded-xl bg-sugar-blush text-sugar-pink"><CakeSlice size={22} /></span>}
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          {fresh && <span data-testid={`admin-order-new-${o.id}`} className="inline-flex items-center gap-1 rounded-full bg-sugar-ink px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-yellow-300"><Sparkles size={11} />New</span>}
          <span className="font-display text-base font-bold text-sugar-ink">#{o.id.slice(-6).toUpperCase()} · {o.customer_name}</span>
          {o.missing_time && o.payment_status !== "pending" && <span data-testid={`admin-order-missing-time-${o.id}`} className="inline-flex items-center gap-1 rounded-full bg-red-500 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white"><AlertTriangle size={11} />Time missing</span>}
        </div>
        <p className="truncate text-xs text-sugar-ink2">{o.items.map((i) => i.style_name).join(", ")}</p>
        <p className="text-xs text-sugar-ink2">{MODE_META[o.mode]?.label} · <b>{o.fulfillment_date}</b> · {o.delivery_method === "pickup" ? "Pickup" : "Delivery"}{o.pickup_time || o.delivery_time ? ` ${o.pickup_time || o.delivery_time}` : ""} · {money(o.total)} · <span className="font-bold" style={{ color: pay.color }}>{pay.label}</span></p>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-2">
        <StatusBadge status={o.status} />
        <ChevronRight size={18} className="text-sugar-muted" />
      </div>
    </button>
  );
};
